import {
    Subject
} from 'one-state-subject/src/Subject';
import { diff, format } from 'one-util-date';
import {
    EmergencyDetails
} from 'one-state-subject';
import {
    EmployerDetails
} from 'one-state-subject';

// ADPAC-316
function sortFunction(a: Subject, b: Subject) {
    const nameA = a.lastname.toLowerCase();
    const nameB = b.lastname.toLowerCase();
    return (nameA > nameB) ? 1 : -1;

}
const checkAge = (dob: any) => {
    let age = "";
    if (dob !== undefined && dob !== null && dob !== "") {
        age = diff(dob).toString();
    }
    return age;
}

export const formatPhoneNumber = (phoneNumberString: any) => {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    if (cleaned.length == 10) {
        return '(' + cleaned.substring(0, 3) + ') ' + cleaned.substring(3, 6) + '-' + cleaned.substring(6, 10);
    }
    return "";
}
const getGender = (gender?: string) => {
    let result = '';
    switch(gender?.toLocaleLowerCase().charAt(0)) {
      case 'm':
        result = 'Male';
        break;
      case 'f':
        result = 'Female';
        break;
      case 'u':
          result = 'Undefined';
          break;
    }
    return result;
  };
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * upcoming Appointments Component
 * @param response has the backend upcoming
 * appointment response
 * @param context has settings etc..
 */
export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    const result: Subject[] = [];

    let subjectresult: any = {
        subjectdata: result,
        error: undefined

    }
    const { log, settings: { epicendpoints, uisettings: { dateformat, prescription_mrn: { mrn_value }, display_patientid } } } = context;
    log.debug("one-epic/meditech", "transformation entered", response);

    // if (response && (response.status >= 400 || response.type == "error")) {
    //     subjectresult.error = response;
    // }
    if (response && (response.success == false )) {
        subjectresult.error = response;
    }
    //ADPAC-348
    else if (response && response.length > 0) {
        const rs = response;
        rs.map((ele: any) => {
            let source: Subject = {
                initials: "",
                id: "",
                middlename: "",
                mrn: "",
                dob: "",
                gender: "",
                age: "",
                contact: "",
                contact_formatted: "",
                address: "",
                lastname: "",
                firstname: "",
                name: "",
                preferredName: [],
                race: "",
                email: "",
                ssn: "",
                zipcode: "",
                displayid: "",
                displayidtype: "",
                prescriptionMRNData: "",
                emergencycontact: [],
                employmentinfo: []
            }
                // const displaydata = ele.ID.filter((object: any) => object.Type === display_patientid)
                // const prescription_MRNValue = ele.ID.filter((mrninfo: any) => mrninfo.Type === mrn_value)
                    source.id = ele?.ID;
                    // source.mrn = id[0].ID;
                    // source.displayid = displaydata[0].ID;
                    // source.displayidtype = displaydata[0].Type;
                    // source.prescriptionMRNData = prescription_MRNValue.length ? prescription_MRNValue[0].ID : "";
                    // source.preferredName = ele.PreferredName;
                    source.dob = ele.BirthDate ? format(ele.BirthDate, dateformat) : "";
                    const age = checkAge(ele.BirthDate);
                    source.age = age ? age : "";
                    //source.age = age ? age + " year old " + ele?.Sex : "";
                    source.gender = ele?.Gender?getGender(ele.Gender):"";
                    source.ssn = ele.NationalIdentifier;
                    let addrstr = "";
                    let phone = "";
                    let phoneNumbers: any = []
                    let email = "";
                    let emergencydata: EmergencyDetails[] = [];
                    let employerinfo: EmployerDetails[] = [];
                    if(ele?.Identifier){
                        ele.Identifier.map((idn:any)=>{
                            if(idn["type"]==="Medical record number"){
                                source.displayidtype="MRN"
                                source.displayid=idn["value"]
                                source.mrn=idn["value"]
                            }
                            if(idn["type"]==="Social Security Number"){
                                source.ssn=idn["value"]
                            }
                        })
                    }
                    if(ele?.Name){
                        ele.Name.map((name:any)=>{
                            source.name=name.family+' '+name.given
                            source.firstname = name.family;
                            source.lastname = name.given;   
                            source.initials = name.family?.charAt(0) + name.given?.charAt(0)
                        })
                    }
                    if(ele?.Telecom){
                       ele.Telecom.forEach((contactdata: any) => {
                  
                            if (contactdata?.use === "home") {
                                phoneNumbers.push({Type:contactdata.use,Number:contactdata.Number})
                                phone = contactdata?.Number
                            }
                            if (contactdata?.use === "old") {
                                phoneNumbers.push({Type:contactdata.use,Number:contactdata.Number})
                                phone = contactdata?.Number
                            }
                            if (contactdata?.use === "mobile") {
                                phoneNumbers.push({Type:contactdata.use,Number:contactdata.Number})
                                phone = contactdata?.Number
                            }
                            if (contactdata?.system === "email") {
                                email = contactdata?.Number
                            }

                        });
                    }
                    if (ele?.Addresses) {
                        ele.Addresses.map((address: any) => {
                            if (address?.use === "home") {
                                addrstr = addrstr.concat(address.city ? address.city + "," : "");
                                addrstr = addrstr.concat(address.state ? address.state + "," : "");
                                addrstr = addrstr.concat(address?.country ? address?.country + "," : "");
                                addrstr = addrstr.concat(address.postalCode ? address.postalCode : "");
                                source.zipcode = address.postalCode;
                            }
                        })
                    }
                    if (ele?.EmergencyContacts) {
                        ele.EmergencyContacts.map((emerge: any) => {

                            let info = {
                                emergename: emerge?.Name ? (emerge.Name?.given + ' ' + emerge.Name?.family): "",
                                contactnumber: "",
                                contactrelation:""
                            }
                            emerge?.Telecom?.forEach((contactdata: any) => {
                                if (contactdata?.use === "home") {
                                    info.contactnumber = contactdata.value
                                }

                                if (contactdata?.use === "mobile" ) {
                                    info.contactnumber = contactdata.value
                                }
                            });
                            emerge?.Relation?.forEach((Rel: any) => {
                                info.contactrelation= Rel?.text ? Rel?.text :""
                                
                            });
                            emergencydata.push(info)

                        })
                        

                    }

                    source.address = addrstr;
                    source.contact = phone;
                    const formatednumber = formatPhoneNumber(phone);
                    source.phoneNumbers = phoneNumbers;
                    source.contact_formatted = formatednumber === "" ? phone : formatednumber;
                    source.email = email;
                    source.emergencycontact = emergencydata;
                    source.employmentinfo = employerinfo;
                
            
            result.push(source);
        })
    }
    // ADPAC-316
    result.sort(sortFunction);
    subjectresult.subjectdata = result;
    return subjectresult;
}



